import { CognitoIdentityProviderClient, GetUserCommand, type GetUserCommandOutput } from "@aws-sdk/client-cognito-identity-provider";
import * as Sentry from "@sentry/react-native";

const client = new CognitoIdentityProviderClient({
  region: process.env.EXPO_PUBLIC_COGNITO_REGION || "us-east-2",
});

function getAttributeValue(attributes: GetUserCommandOutput["UserAttributes"], attributeName: string): string | undefined {
  const attribute = attributes?.find((attr) => attr.Name === attributeName);
  return attribute?.Value;
}

export async function validateToken(token: string): Promise<{
  sub: string;
  email: string;
  given_name?: string;
  family_name?: string;
  phone_number?: string;
  updated_at?: string;
}> {
  if (!token) {
    throw new Error("Token is required for validation.");
  }

  const command = new GetUserCommand({
    AccessToken: token,
  });

  try {
    const data: GetUserCommandOutput = await client.send(command);

    if (!data.UserAttributes) {
      throw new Error("No user attributes found in the token.");
    }

    const sub = getAttributeValue(data.UserAttributes, "sub");
    const email = getAttributeValue(data.UserAttributes, "email");
    const given_name = getAttributeValue(data.UserAttributes, "given_name");
    const family_name = getAttributeValue(data.UserAttributes, "family_name");
    const phone_number = getAttributeValue(data.UserAttributes, "phone_number");
    const updated_at = getAttributeValue(data.UserAttributes, "updated_at");

    if (!sub || !email) {
      throw new Error("Required attributes 'sub' or 'email' are missing.");
    }

    return { sub, email, given_name, family_name, phone_number, updated_at };
  } catch (error) {
    Sentry.captureException(error);
    const errorMessage = error instanceof Error ? `Token validation failed: ${error.message}` : "An unknown error occurred while validating the token.";
    console.error(errorMessage);
    throw new Error(errorMessage);
  }
}
